export default "__VITE_ASSET__oZO4w9sd__"